import { baseUrl } from "util/APIBaseUrl";
import postRequest from "util/APIHelperPost";

// eslint-disable-next-line import/prefer-default-export
export const forgotPasswordV2Api = async (body) => {
  const requestPath = `${baseUrl}/v2/forgotPassword`;
  const { payload } = await postRequest(requestPath, JSON.stringify(body));
  if (payload?.error || payload?.error?.length > 0) {
    return { ...payload, ok: false };
  }
  return { ...payload, ok: true };
};
